module.exports = __webpack_public_path__ + "img/Frame.2fef8db6.svg";